/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import $store from '../store'

// import { AuthService } from '@/services/auth.service'
import { API_URL } from '../.env'
import { AuthService } from './auth.service'

export class TicketHttp {
    constructor(status) {
        this.isAuth = status && status.auth ? status.auth : false
        this.instance = axios.create({
            baseURL: API_URL
        })

        return this.init()
    }
 
    init() {
        if (this.isAuth) {
            this.instance.interceptors.request.use( request => {
                if ( localStorage.getItem('ACCESS_TOKEN') )
                    var access_token = localStorage.getItem('ACCESS_TOKEN');
                else var access_token = '';
               request.headers.Authorization = 'Bearer '+access_token
                return request
            }, error => {
                return Promise.reject(error)
            })
            this.instance.interceptors.response.use(response => {
                return response
            }, (error) => {
                if( error.response.status === 401 ){
                    setTimeout(function () {
                        localStorage.removeItem('ACCESS_TOKEN')
                        location.reload()
                    },1500)
                }
            })
        }
        this.instance.interceptors.request.use(request => {
            request.headers['Content-Type'] = 'application/json'
            return request
        })
      
        return this.instance
    }
}
